<template>
  <ion-page>
    <master-layout pageTitle="درآمد سرویس ها">
      <ion-card>
        <ion-card-content>
          <DataTable :headers="headers" :route="route"></DataTable>
          <div class="between">
            <div></div>
            <div>
              جمع درآمد :
              <money :number="total_service_income"></money>
            </div>
          </div>
        </ion-card-content>
      </ion-card>
    </master-layout>
  </ion-page>
</template>

<script>
import DataTable from "@/components/DataTable";
import {
  IonCard, IonCardContent, IonPage
} from "@ionic/vue";
import {mapActions} from "vuex";
import Money from '/src/components/Money'

export default {
  data()
  {
    return {
      id: null,
      total_service_income : 0,
      route:'serviceProfit/ListAjax',
      headers: [
        'عنوان',
        'دسته بندی',
        'تعداد',
        'جمع',
      ]
    };
  },
  async created()
  {
    this.id = this.$route.params.id;
  },
  methods: {
    ...mapActions("app", {
      getIncomeReportItems: 'getIncomeReportItems',
    }),
  },
  async mounted()
  {
    const check = await this.getIncomeReportItems()
    if (check && check.ok)
    {
      this.total_service_income = check.total_service_income;
    }
  },
  components: {
    IonCard, IonCardContent, DataTable, IonPage,Money
  },
  watch: {
    $route()
    {
      if (this.$route.fullPath.indexOf('serviceProfit/ListAjax') >= 0)
      {
        this.route = 'serviceProfit/ListAjax?t='+(new Date().getTime())
      }
    }
  }
};
</script>

<style scoped>
.between
{
  display: flex;
  justify-content: space-between;
}
</style>